export default {
  methods: {
    getProductName(product) {
      return product?.CP_PRODUCT_DESC || product?.PRODUCT_DESC || '';
    }
  }
};
